import { useEffect } from "react";
import TagManager from "react-gtm-module";
import { gtmId } from "@util/constant";

export const useInitGTM = () => {
  useEffect(() => {
    if (typeof window === "undefined" || !gtmId) return;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((window as any).gtmInitialized) return; // prevent double init

    TagManager.initialize({ gtmId: gtmId });
    (window as any).gtmInitialized = true; // eslint-disable-line @typescript-eslint/no-explicit-any
  }, []);
};
